//This class serves as a request container for changes to an auction while the auction is live. Special care has to be taken to avoid conflicting auction modifications by locking the auction during such an operation.
export class ReserveCreditRequest{
    public userId!:string;
    public businessId!:string;
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public reserveCredit!:number
}